import React, { useState } from "react";
import CollapseSection from "../../../collapse/CollapseSection";
import { Grid2 } from "@mui/material";
import SelectInput from "../../../input/SelectInput";
import { ROLES } from "../../../../../utils/constants";
import { Control, Controller, UseFormWatch } from "react-hook-form";
import SelectApiInput from "../../../input/SelectApiInput";

interface IRoleSection {
  control: Control<any>;
  watch: UseFormWatch<any>;
}

function RoleSection({ control, watch }: IRoleSection) {
  const [show, setShow] = useState<boolean>(true);

  const visible = watch("visible_to");

  return (
    <CollapseSection
      title="Phân quyền"
      show={show}
      onCollapse={() => setShow(!show)}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 6 }}>
          <Controller
            name="visible_to"
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <SelectInput
                  label="Quyền truy cập"
                  labelWidth="25%"
                  placeholder="Chọn quyền truy cập"
                  options={ROLES}
                  value={value}
                  defaultValue={value}
                  onChange={onChange}
                />
              );
            }}
          />
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          {5 === Number(visible) && (
            <Controller
              control={control}
              name="usergroup"
              render={({ field: { value, onChange } }) => {
                return (
                  <SelectApiInput
                    label="Nhóm người sử dụng"
                    labelWidth="25%"
                    placeholder="Chọn nhóm người sử dụng có quyền xem"
                    apiCode="usergroup"
                    searchFields={['group_name',]}
                    checkEqual={(value, option) => value?._id === option?._id}
                    getOptionLabel={option => option.group_name || option?._id}
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
          )}
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default RoleSection;
